import { Button } from '@commenda/kakashi';
import type { ReactNode } from 'react';

interface PanelLauncherProps {
  label: string;
  icon: ReactNode;
  onClick: () => void;
}

/** The floating button that opens a side panel. Every launcher is this one button, so every panel
 * entry point reads as one kind of control. The host positions it. */
export const PanelLauncher = ({ label, icon, onClick }: PanelLauncherProps) => (
  <Button
    variant="primary"
    size="sm"
    aria-label={`Open ${label}`}
    onClick={onClick}
    className="shadow-lg"
    leftIcon={icon}
  >
    {label}
  </Button>
);
